import { GetterTree } from 'vuex'
import { EventsState } from './types'
import { RootState } from '../types'

export const getters: GetterTree<EventsState, RootState> = {
    isBatchLocked(state): boolean {
        return state.isBatchLocked;
    }
}
